import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import { Box, Checkbox } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import Typography from './Typography.js';

var SlotTemplateButton = function (_a) {
    var icon = _a.icon, hoverIcon = _a.hoverIcon, title = _a.title, checkbox = _a.checkbox, isSelected = _a.isSelected, onClick = _a.onClick, minHeight = _a.minHeight;
    var _b = React.useState(isSelected || false), isCardSelected = _b[0], setIsCardSelected = _b[1];
    useEffect(function () {
        setIsCardSelected(isSelected || false);
    }, [isSelected]);
    var handleOnClick = function () {
        setIsCardSelected(!isCardSelected);
        onClick && onClick(!isCardSelected);
    };
    return (React.createElement(Box, { sx: __assign(__assign(__assign({ display: "flex", flexDirection: "column", border: isCardSelected ? "1px solid var(--Neutral-800, #1F2329)" : "1px solid var(--Neutral-400, #DADEE5)", maxW: 180, minWidth: 180 }, (minHeight ? { minHeight: minHeight } : {})), { borderRadius: "8px" }), (isCardSelected
            ? __assign({ "&:hover": {
                    cursor: "pointer",
                } }, (hoverIcon ? {
                ".icon": {
                    display: "none !important",
                },
                ".hover-icon": {
                    display: "flex !important",
                },
            } : {})) : {
            "&:hover": __assign({ border: "1px solid var(--Secondary-900, #6A7381)", cursor: "pointer", ".card-button-text": {
                    background: "neutrals.600",
                    p: {
                        color: "#fff",
                    },
                } }, (hoverIcon ? {
                ".icon": {
                    display: "none !important",
                },
                ".hover-icon": {
                    display: "flex !important",
                },
            } : {})),
        })), onClick: function (e) {
            e.preventDefault();
            handleOnClick();
        } },
        React.createElement(Box, { sx: {
                display: "flex",
                flexDirection: "column",
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                borderBottom: "1px solid #DADEE5",
            }, p: 4 },
            checkbox && (React.createElement(Box, { sx: { alignSelf: "flex-end" } },
                React.createElement(Checkbox, { isChecked: isCardSelected, onChange: function (e) {
                        e.preventDefault();
                        handleOnClick();
                    } }))),
            React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "center", flex: 1, className: "icon" }, icon),
            hoverIcon && React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "center", flex: 1, hidden: true, className: "hover-icon" }, hoverIcon)),
        React.createElement(Box, { className: "card-button-text", sx: {
                background: isCardSelected ? "neutrals.800" : "neutrals.200",
                padding: "17px",
                borderRadius: "0px 0px 8px 8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                maxH: "50px",
                textAlign: "center",
            } },
            React.createElement(Typography, { variant: "xsmall-i", fontWeight: 500, color: isCardSelected ? "#fff" : "neutrals.900" }, title))));
};

export { SlotTemplateButton as default };
//# sourceMappingURL=SlotTemplateButton.js.map
